import React from "react";

import { Button, Text } from "@pushpress/shared-components";
import styles from "./SetupAvailabilitySection.module.scss";

export interface SetupAvailabilitySectionProps {
  userUuid?: string;
  message?: string;
  loading?: boolean;
  reminderDisabled?: boolean;
  onSendClick: (userUuid: string) => void;
}

function SetupAvailabilitySection(props: SetupAvailabilitySectionProps) {
  const { message, onSendClick, userUuid, loading, reminderDisabled } = props;

  return (
    <div className={styles.root}>
      <Text variant="body-lg" color="wolf-800" className={styles.message}>
        {message}
      </Text>
      <div className={styles.actions}>
        <Button
          text="Send a reminder"
          buttonType="primary"
          type="button"
          loading={loading}
          fullWidth
          disabled={reminderDisabled}
          onClick={() => onSendClick(userUuid)}
        />
        <Button
          component="a"
          text="Setup now"
          buttonType="text"
          type="button"
          href={`appointments/working-hours/${userUuid}`}
          target="_blank"
          fullWidth
        />
      </div>
    </div>
  );
}

export default SetupAvailabilitySection;
